import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { BackrsIcon, BackrsIcons } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';

import { Theme, Box, SxProps, Typography } from '@mui/material';

const ICON_DIAMETER_LARGE = 28;
const ICON_DIAMETER_SMALL = 20;

type PanelNuggetHeaderProps = Readonly<{
  iconName: BackrsIcons;
  title: string;
  subTitle?: string;
  size?: 'SMALL' | 'LARGE';
}>;

export const PanelNuggetHeader = ({ iconName, title, subTitle, size }: PanelNuggetHeaderProps) => {
  return (
    <Box
      sx={{ ...containerStyle, ...(size === 'SMALL' ? smallContainerStyle : {}) } as SxProps<Theme>}
    >
      <Box sx={panelNuggetHeaderStyle}>
        <Box minWidth={size === 'SMALL' ? ICON_DIAMETER_SMALL : ICON_DIAMETER_LARGE}>
          <BackrsIcon
            name={iconName}
            alt={title}
            color={appColors.color.blue1}
            width={size === 'SMALL' ? ICON_DIAMETER_SMALL : ICON_DIAMETER_LARGE}
            height={size === 'SMALL' ? ICON_DIAMETER_SMALL : ICON_DIAMETER_LARGE}
          />
        </Box>
        <Box sx={titleSubtitleContainerStyle}>
          <Typography
            sx={{ ...titleStyle, ...(size === 'SMALL' ? smallTitleStyle : {}) } as SxProps<Theme>}
          >
            {title}
          </Typography>
          {subTitle && (
            <Typography
              sx={
                {
                  ...subTitleStyle,
                  ...(size === 'SMALL' ? smallSubTitleStyle : {}),
                } as SxProps<Theme>
              }
            >
              {subTitle}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  flexDirection: 'column',
  gap: 2,
  display: 'flex',
};

const smallContainerStyle: SxProps<Theme> = {
  gap: 0.5,
};

const panelNuggetHeaderStyle: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
};

const titleSubtitleContainerStyle: SxProps<Theme> = {
  pb: 1,
};

const titleStyle: SxProps<Theme> = {
  fontWeight: 700,
  lineHeight: '20px',
  fontSize: '18px',
};

const subTitleStyle: SxProps<Theme> = {
  fontWeight: 500,
  lineHeight: '20px',
  fontSize: '18px',
};

const smallTitleStyle: SxProps<Theme> = {
  fontSize: '12pt',
  lineHeight: '1.4',
};

const smallSubTitleStyle: SxProps<Theme> = {
  fontSize: '12pt',
  lineHeight: '1.4',
};
